<template>
  <div class="chart-area">
    <div class="time-select">
      <el-date-picker
        v-model="timeSpan"
        value-format="yyyy-MM-dd"
        size="mini"
        type="daterange"
        :clearable="false"
        range-separator="-"
        start-placeholder="开始日期(含)"
        end-placeholder="结束日期(不含)"
        @change="LoadData"
      >
      </el-date-picker>
    </div>
    <div class="companyquery-chart-warper">
      <div v-if="isLoading">加载中...</div>
      <line-chart
        v-else
        height="380px"
        :view-model="dayCounts"
        :prop-map="propMap"
      >
      </line-chart>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import LineChart from '@/components/LineChart.vue'
import { ListVinQueryDayChange } from '../services'
export default {
  name: 'CompanyQueryLineChart',
  components: { LineChart },
  props: {
    companyId: {
      type: Number,
      default () {
        return 0
      }
    },
    chartType: {
      type: String,
      default () {
        return 'vin'
      }
    }
  },
  data () {
    return {
      isLoading: false,
      propMap: {
        xAxis: 'date',
        dayCount: '查询次数'
      },
      timeSpan: [
        moment().subtract(30, 'day').format('YYYY-MM-DD'),
        moment().add(1, 'day').format('YYYY-MM-DD')
      ],
      dayCounts: []
    }
  },
  mounted () {
    this.LoadData()
  },
  methods: {
    LoadData () {
      this.isLoading = true
      ListVinQueryDayChange(this.chartType, this.timeSpan[0], this.timeSpan[1], this.companyId).then(res => {
        this.dayCounts = res
        this.isLoading = false
      })
    }
  }
}
</script>
